module.exports = __webpack_public_path__ + "img/button_1.4e637820.png";